import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

// P8 new & returning — Returning-customers (reorder) campaign.
export const campP8NrReorder: FaireAdCampaignEntity = {
  token: "camp_p8_nr_reorder",
  type: "adCampaign",
  advertiserProfileToken: "adv_p8_new_returning",
  segment: "REORDER_MARKETPLACE",
  status: "RUNNING",
  monthlyBudgetDollars: 9000,
  startedRunningAt: "2024-11-19",
  segmentMetrics: {
    numReorderConversions: 393,
    salesDollars: 116238,
    totalAdsSpendDollars: 19998,
    returnOnAdSpend: 5.81,
  },
  performancePeriodTokens: [
    "perf_p8_nr_reorder_202604",
    "perf_p8_nr_reorder_202605",
    "perf_p8_nr_reorder_202606",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
